// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_8rX","cls2":"SingularMentionCitationModal-cls2_Nnj SingularMentionCitationModal-cls1_8rX"};